'use strict';

function parse(reader) {
    reader.readUInt8("version");
    reader.readUInt8("data.ucp", value => value.toString(16));
    reader.readString(12, "data.sn");
    reader.readString(4, "data.hardware");
    reader.readString(4, "data.firmware");
    reader.readString(4, "data.model");
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/lora/v1_2/analog/attribute-report-parser.js